<template>
  <img class="img-fluid  mx-auto d-block" :src="src" :alt="alt" />
</template>

<script>
export default {
  name: 'logo',
  props: ['src', 'alt'],
};
</script>

<style lang="scss" scoped>
.img-fluid {
  max-height: 100%;
  max-width: 100%;
}
img {
  padding-right: 15px;
}
</style>
